// import Home from '@/pages/Home';
import MarketGuideline from '@/pages/marketGuideline/outer';
import Home from '@/pages/Home/outer.jsx';
import BrandBook from '@/pages/BrandBook/outer.jsx';
import SearchResult from '@/pages/SearchResult/outer.jsx';
import BrandAggregation from "@/pages/BrandAggregation/outer.jsx";
import AssetDetail from "@/pages/AssetDetail/outer.jsx";
import TermsOfUse from '@/pages/TermsOfUse'; //固定介绍页
import InAppSpecs from "@/pages/InAppSpecs/outer.jsx";
import BrandDesigns from "@/pages/BrandDesigns/outer.jsx"; //品牌市场首页

export const routeConfig = [
    {
        path: '/',
        component: Home,
        isOpcity: true,
        isNoBlur: true
    },
    {
        path: '/brand-guidelines',
        component: BrandBook
    },
    {
        path: "/search-result",
        component: SearchResult
    },
    // {
    //     path: '/marketGuideline',
    //     component: MarketGuideline,
    //     isOpcity: true
    // },
    {
        path: "/in-app-specs",
        component: InAppSpecs
    },
    {
        path: "/brand-designs",
        component: BrandDesigns
    },
    {
        path: "/brand-guidelines/sections",
        component: BrandAggregation
    },
    {
        path: "/brand-guidelines/detail",
        component: AssetDetail
    },
    {
        path: "/terms-of-use",
        component: TermsOfUse
    }
];
